// src/pages/Pricing.js
import '../styles/pricing.css';

function Pricing() {
    // Replace these with your real Stripe Payment Link URLs from your Stripe Dashboard
    const paymentLinks = {
        starter: 'https://buy.stripe.com/test_6oU3cwbO524W2213PUgjC00',
        growth: 'https://buy.stripe.com/prod_TC9CrQIbeaGfiv',
        enterprise: '/sales', // Contact sales manually
    };

    const handleRedirect = (url) => {
        window.location.href = url;
    };

    return (
        <div className="pricing-page">
            <section className="container">
                <h1>Flexible Pricing Plans</h1>
                <p>Choose a plan that fits your business needs. No hidden fees, cancel anytime.</p>

                <div className="pricing-grid">
                    {/* Starter Plan */}
                    <div className="pricing-card">
                        <h2>Starter</h2>
                        <p className="price">$49/month</p>
                        <ul>
                            <li>Up to 10 vehicles</li>
                            <li>Email & SMS reminders</li>
                            <li>Basic reports</li>
                            <li>Email support</li>
                        </ul>
                        <button
                            className="btn btn-primary"
                            onClick={() => handleRedirect(paymentLinks.starter)}
                        >
                            Start Free Trial
                        </button>
                    </div>

                    {/* Growth Plan */}
                    <div className="pricing-card featured">
                        <h2>Growth</h2>
                        <p className="price">$99/month</p>
                        <ul>
                            <li>Up to 50 vehicles</li>
                            <li>Advanced analytics</li>
                            <li>Fleet tracking</li>
                            <li>Priority support</li>
                        </ul>
                        <button
                            className="btn btn-primary"
                            onClick={() => handleRedirect(paymentLinks.growth)}
                        >
                            Start Free Trial
                        </button>
                    </div>

                    {/* Enterprise Plan */}
                    <div className="pricing-card">
                        <h2>Enterprise</h2>
                        <p className="price">Custom</p>
                        <ul>
                            <li>Unlimited vehicles</li>
                            <li>Custom integrations</li>
                            <li>Dedicated account manager</li>
                            <li>24/7 support</li>
                        </ul>
                        <button
                            className="btn btn-outline"
                            onClick={() => handleRedirect(paymentLinks.enterprise)}
                        >
                            Contact Sales
                        </button>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Pricing;
